import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import SVGA from 'svgaplayerweb'

import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    setDocumentTitle('Level')
    this.familyStore = this.props.store.register('activity/family')
  }

  state = {
    // 在使用 initialSlide 的时候，默认会调用一次 slideNextTransitionStart 方法; 作为阀门，第一次进来关闭
    initFlag: false,
    lang: langM.ar,
    // 当前等级
    levelState: 1,
    // 查看显示等级
    pointState: 1,
    // swiper对象
    swiperObj: null,
    // 规则显隐
    ruleState: false,
    // 规则第一次关闭特效，关闭阀门
    isRule: false,
    rwShow: false,
    rwImg: "",
    language:'en',
    info: {},
    currentPoint: 0,
    needPoint: 0,
    maxPoint: 0,
    date: "",
    icon: "",
    name: "",
    progress: 0,
    lv: {},
  }

  async componentWillMount() {
    // 初始化语言
    let { language } = this.props.location.query
    language =await getlang(language)
    console.log('language', language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)


    await this.familyStore.GetUserInfoWeb(uid)

    // 请求家族对象接口
    let { familyId } = this.props.location.query
    console.log(familyId)
    let level = await this.familyStore.getLevel(parseInt(familyId))
    console.log(level, 'level')

    const pointMax = level && level.info && level.info.pointMax
    const point = level && level.info && level.info.point

    this.setState({
      info: level && level.info,
      currentPoint: (level.info && level.info.point),
      maxPoint: (pointMax),
      needPoint: (pointMax - point),
      date: level.info && level.info.validityTime,
      icon: level.info && level.info.icon,
      name: level.info && level.info.name,
      levelState: level.info && level.info.lv,
      pointState: level.info && level.info.lv,
      progress: this.progressCal(point, pointMax),
      lv: level.lv,
    })
    // let getFamilyLevel = await xxx(familyId)
    // this.setState({
    //   levelState: getFamilyLevel
    // })




    // 获取作用域
    const that = this

    // 分页器
    const mySwiper = new Swiper('.swiper', {
      initialSlide: (that.state.levelState - 1) || 0,
      // 如果需要前进后退按钮
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideChange: function () {
          // alert('改变了，activeIndex为' + this.activeIndex);
          this.slideTo(this.activeIndex)

          // if (that.state.pointState == 1) return
          that.setState({
            pointState: this.activeIndex + 1
          })

        },
      }
    })
    this.setState({
      // 初始化swiper对象
      swiperObj: mySwiper,
      // 关闭阀门
      initFlag: true,
    })
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid,
    })
  }

  componentDidMount() {
    new SVGA.autoload(document.querySelector('#demoCanvas'))
    new SVGA.autoload(document.querySelector('#demoCanvas2'))
    new SVGA.autoload(document.querySelector('#demoCanvas3'))
    new SVGA.autoload(document.querySelector('#demoCanvas4'))
  }

  progressCal(point, pointMax) {
    if (100 - parseInt((point / pointMax) * 100) <= 2) {
      return "2"
    } else {
      return 100 - parseInt((point / pointMax) * 100)
    }
  }

  // 我的家族提示框位置
  tipsState() {
    switch (this.state.levelState) {
      case 1:
        return "tips-state-1"
        break
      case 2:
        return "tips-state-2"
        break
      case 3:
        return "tips-state-3"
        break
      case 4:
        return "tips-state-4"
        break
    }
  }

  // 家族等级文本
  familyTxt() {
    switch (this.state.pointState) {
      case 1:
        return this.state.lang.family1
        break
      case 2:
        return this.state.lang.family2
        break
      case 3:
        return this.state.lang.family3
        break
      case 4:
        return this.state.lang.family4
        break
      default:
        return this.state.lang.family1
        break
    }
  }

  // 家族等级背景图片
  titleBg() {
    switch (this.state.pointState) {
      case 1:
        return "url('/img/activity/familyLevel/lt1.png')"
        break
      case 2:
        return "url('/img/activity/familyLevel/lt2.png')"
        break
      case 3:
        return "url('/img/activity/familyLevel/lt3.png')"
        break
      case 4:
        return "url('/img/activity/familyLevel/lt4.png')"
        break
    }
  }


  prevPage() {
    // 到了第一页就不做操作
    if (this.state.pointState == 1) return
    // 递减
    const num = this.state.pointState - 1
    this.setState({
      pointState: num
    })
    // 触发上一页
    this.state.swiperObj.slidePrev()
  }

  nextPage() {
    // 到了最后就不做操作
    if (this.state.pointState == 4) return
    // 递增
    const num = this.state.pointState + 1
    this.setState({
      pointState: num
    })
    // 触发下一页
    this.state.swiperObj.slideNext()
  }

  pointState() {
    if (this.state.pointState == 1) {
      return "family-level-banner-point1"
    }
    if (this.state.pointState == 2) {
      return "family-level-banner-point2"
    }
    if (this.state.pointState == 3) {
      return "family-level-banner-point3"
    }
    if (this.state.pointState == 4) {
      return "family-level-banner-point4"
    }
  }

  onRuleState(state) {
    this.setState({
      ruleState: state
    })
  }

  svgaPic() {
    if (this.state.pointState == 1) {
      return "1"
    }
    if (this.state.pointState == 2) {
      return "2"
    }
    if (this.state.pointState == 3) {
      return "3"
    }
    if (this.state.pointState == 4) {
      return "4"
    }
  }

  rwList() {
    return [
      {
        isShow: this.state.pointState >= 1 ? true : false,
        img: "/img/activity/familyLevel/level/admin.png",
        name: "Admin"
      },
      {
        isShow: this.state.pointState >= 1 ? true : false,
        img: "/img/activity/familyLevel/level/member.png",
        name: "Member"
      },
      {
        isShow: this.state.pointState >= 1 ? true : false,
        img: "/img/activity/familyLevel/level/nameplate.png",
        name: "Nameplate"
      },
      {
        isShow: this.state.pointState >= 2 ? true : false,
        img: "/img/activity/familyLevel/level/nameplate_diy.png",
        name: "Nameplate DIY"
      },
      {
        isShow: this.state.pointState >= 3 ? true : false,
        img: "/img/activity/familyLevel/level/head.png",
        name: "Head"
      },
      {
        isShow: this.state.pointState >= 4 ? true : false,
        img: "/img/activity/familyLevel/level/car.png",
        name: "Car"
      },
      {
        isShow: this.state.pointState >= 4 ? true : false,
        img: "/img/activity/familyLevel/level/tx.png",
        name: "Special Effects"
      },
    ]
  }

  rewardComp() {
    return (
      <div className="family-content">
        <div className="f-top">{this.state.lang.levelTitle}</div>
        <div className="f-center">
          <div className="f-item-wrap">
            {
              this.rwList().map((item, index) => {
                if (item.isShow) {
                  return (
                    <div className="f-item" key={index}>
                      <div className="f-item-img" onClick={() => { this.setState({ rwShow: true, rwImg: item.img }) }}>
                        <img src={item.img} alt="" />
                      </div>
                      <div className="f-item-name">{item.name}</div>
                    </div>
                  )
                }
              })
            }
          </div>
        </div>
        <div className="f-bottom"></div>
      </div>
    )
  }

  experienceComp() {
    return (
      <div className="family-experience">
        {/* 当前等级经验展示 */}
        <div className="family-experience-content" style={{ display: `${this.state.levelState == this.state.pointState && this.state.info != null && this.state.needPoint > 0 ? "block" : "none"}` }}>
          <div className="title">
            <div className='txt'>EXP:&nbsp;&nbsp;{this.state.currentPoint}</div>
            <div className='question' onClick={() => { this.onRuleState(true); this.setState({ isRule: true }) }}>?</div>
          </div>
          <div className="desc">
            {this.state.lang.nextLevel(this.state.needPoint)}
          </div>
          <div className="experience">
            <div className="experience-wrap">
              <div className="experience-box" style={{ transform: `translateX(-${this.state.progress}%)` }}>
                <div className="experience-inner-box"></div>
              </div>
            </div>
          </div>
          <div className="experience-need">
            <div>{this.state.currentPoint}</div>
            <div>{this.state.maxPoint}</div>
          </div>
        </div>
        {/* 高于或者低于当前等级显示 */}
        <div className="family-experience-content2"
          // 不相等情况下
          // 所需要经验小于0 = 满级
          style={{ display: `${this.state.levelState != this.state.pointState || this.state.needPoint < 0 ? "block" : "none"}` }}>
          <div className="title">
            {this.state.pointState == 1 ? this.state.lang.family1 : ""}
            {this.state.pointState == 2 ? this.state.lang.family2 : ""}
            {this.state.pointState == 3 ? this.state.lang.family3 : ""}
            {this.state.pointState == 4 ? this.state.lang.family4 : ""}
          </div>
          <div className="desc" style={{ display: `${this.state.levelState <= this.state.pointState && this.state.pointState == 1 ? "block" : "none"}` }}>
            {this.state.lang.needLevel(this.state.lv[1])}
          </div>
          <div className="desc" style={{ display: `${this.state.levelState <= this.state.pointState && this.state.pointState == 2 ? "block" : "none"}` }}>
            {this.state.lang.needLevel(this.state.lv[2])}
          </div>
          <div className="desc" style={{ display: `${this.state.levelState <= this.state.pointState && this.state.pointState == 3 ? "block" : "none"}` }}>
            {this.state.lang.needLevel(this.state.lv[3])}
          </div>
          <div className="desc" style={{ display: `${this.state.levelState < this.state.pointState && this.state.pointState == 4 ? "block" : "none"}` }}>
            {this.state.lang.needLevel(this.state.lv[4])}
          </div>
          <div className="desc2" style={{ display: `${this.state.levelState > this.state.pointState || this.state.needPoint <= 0 ? "block" : "none"}` }}>
            {this.state.lang.levelExceed}
          </div>
        </div>
      </div>
    )
  }

  srcComp() {
    return (
      <div className="pic" style={{ display: "none" }}>
        <img src="/img/activity/familyLevel/lt1.png" alt="" />
        <img src="/img/activity/familyLevel/lt2.png" alt="" />
        <img src="/img/activity/familyLevel/lt3.png" alt="" />
        <img src="/img/activity/familyLevel/lt4.png" alt="" />
        <img src="/img/activity/familyLevel/rule_bg.png" alt="" />
        <img src="/img/activity/familyLevel/rw.png" alt="" />
      </div>
    )
  }

  rewardPopUp() {
    return (
      <div className="family-level-reward-wrap"
        onClick={() => { this.setState({ rwShow: false }) }}
        style={{ display: `${this.state.rwShow ? "flex" : "none"}` }}>
        <div className="family-level-reward">
          <div className="family-level-reward-box">
            <img src={this.state.rwImg} alt="" />
          </div>
        </div>
      </div>
    )
  }

  sssrender() {

    return (
      <div className={`family-level-main-wrap`}>

        {/* 奖励弹窗 */}
        {this.rewardPopUp()}

        <div className={`family-level-rule ${this.state.ruleState ? "family-level-rule1" : this.state.isRule && "family-level-rule2"}`}>
          <div className="family-level-rule-close" onClick={() => this.onRuleState(false)}></div>
          <div className="family-level-rule-tile">{this.state.lang.rule}</div>
          <div style={{ direction: `${this.state.language == 'ar' ? "rtl" : ""}` }} className="family-level-rule-content" dangerouslySetInnerHTML={{ __html: this.state.lang.ruleTxt }}></div>
        </div>

        <div className="family-level-banner">
          <div className="family-level-banner-info">
            <div className="ava">
              <div className="ava-bg"></div>
              <img src={this.state.icon} alt="" />
            </div>
            <div className="name">{this.state.name}</div>
          </div>
          <div className="family-level-banner-progress-items">
            <div className={`family-level-banner-progress-item1 ${this.state.pointState == 1 ? "i1" : ""}`}>
              {this.state.lang.steel}
            </div>
            <div className={`family-level-banner-progress-item2 ${this.state.pointState == 2 ? "i2" : ""}`}>
              {this.state.lang.bronze}
            </div>
            <div className={`family-level-banner-progress-item3 ${this.state.pointState == 3 ? "i3" : ""}`}>
              {this.state.lang.silver}
            </div>
            <div className={`family-level-banner-progress-item4 ${this.state.pointState == 4 ? "i4" : ""}`}>
              {this.state.lang.gold}
            </div>
          </div>
          <div className="family-level-banner-progress">
            <div className="family-level-banner-progress-levels">
              <div
                className={`family-level-banner-progress-level1 ${this.state.levelState == 1 ? "level-active" : ""}`}
                onClick={() => { this.state.swiperObj.slideTo(0); this.setState({ pointState: 1 }); }}
              ></div>
              <div
                className={`family-level-banner-progress-level2 ${this.state.levelState == 2 ? "level-active" : ""}`}
                onClick={() => { this.state.swiperObj.slideTo(1); this.setState({ pointState: 2 }); }}
              ></div>
              <div
                className={`family-level-banner-progress-level3 ${this.state.levelState == 3 ? "level-active" : ""}`}
                onClick={() => { this.state.swiperObj.slideTo(2); this.setState({ pointState: 3 }); }}
              ></div>
              <div
                className={`family-level-banner-progress-level4 ${this.state.levelState == 4 ? "level-active" : ""}`}
                onClick={() => { this.state.swiperObj.slideTo(3); this.setState({ pointState: 4 }); }}
              ></div>
              <div className={`family-level-banner-progress-level-tips ${this.tipsState()}`} style={{ display: `${this.state.info == null ? "none" : "block"}` }}>{this.state.lang.myF}</div>
              <div className={`family-level-banner-point ${this.pointState()}`} style={{ display: `${this.state.levelState == this.state.pointState ? "none" : "block"}` }}></div>
            </div>
          </div>


          <div className="swiper">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div src={`/img/activity/familyLevel/1.svga`} id="demoCanvas"></div>
              </div>
              <div className="swiper-slide">
                <div src={`/img/activity/familyLevel/2.svga`} id="demoCanvas2"></div>
              </div>
              <div className="swiper-slide">
                <div src={`/img/activity/familyLevel/3.svga`} id="demoCanvas3"></div>
              </div>
              <div className="swiper-slide">
                <div src={`/img/activity/familyLevel/4.svga`} id="demoCanvas4"></div>
              </div>
            </div>
            <div className="prevPage" onClick={() => this.prevPage()}></div>
            <div className="nextPage" onClick={() => this.nextPage()}></div>
          </div>

          <div className="family-level-banner-progress-title" style={{ backgroundImage: `${this.titleBg()}` }}>
            {this.familyTxt()}
          </div>
          <div className="family-level-banner-progress-cd" style={{ display: `${this.state.levelState == this.state.pointState && this.state.info != null ? "block" : "none"}` }}>
            {this.state.lang.date(this.state.date)}
          </div>
        </div>

        {/* 经验模块 */}
        {this.experienceComp()}

        {/* 奖励 */}
        {this.rewardComp()}

        {/* 资源加载 */}
        {this.srcComp()}

      </div>
    )
  }

  render(){
    return <div style={{width:'7.5rem', textAlign:'center', margin:'1rem auto',fontSize:'0.32rem'}}>{this.state.lang.tips}</div>
  }
}


// WEBPACK FOOTER //
// src/pages/activity/familyLevel/index.js